import { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/client';
import { useAuth } from './AuthContext';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
    const { usuario, actualizarUsuario } = useAuth();
    const [tema, setTema] = useState(() => {
        return localStorage.getItem('chucho_tema') || usuario?.tema_preferido || 'oscuro';
    });

    useEffect(() => {
        document.documentElement.setAttribute('data-tema', tema);
        localStorage.setItem('chucho_tema', tema);
    }, [tema]);

    useEffect(() => {
        if (usuario?.tema_preferido && usuario.tema_preferido !== tema) {
            setTema(usuario.tema_preferido);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usuario]);

    const cambiarTema = async () => {
        const nuevo = tema === 'oscuro' ? 'claro' : 'oscuro';
        setTema(nuevo);
        if (usuario) {
            try {
                await api.put('/usuarios/tema', { tema: nuevo });
                actualizarUsuario({ tema_preferido: nuevo });
            } catch {}
        }
    };

    return (
        <ThemeContext.Provider value={{ tema, cambiarTema }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
